import Toast from 'goodeggs-toast';

export default __filename;
angular
  .module(__filename, ['ui.router', 'ngToast'])

  .factory(
    'toaster',
    ngInject((ngToast) => new Toast(ngToast)),
  );
